export default __webpack_public_path__ + "static/media/5.aef5161d.jpg";